import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import FormInputText from '../../../../common/Forms/FormTextField';
import CMPFormInputText from '../../../../common/Forms/CMPFormTextField';
import { useDispatch } from 'react-redux';
import { batch } from 'react-redux'
import {
  setOracCmpDt1,
  setOrasCmpDt2,
  setOrasCmpDt3,
  setOrasGls1,
  setOrasGls2,
  setOrasGls3,
  setOrasObj1,
  setOrasObj2,
  setOrasObj3,
  setOrasTgtDt1,
  setOrasTgtDt2,
  setOrasTgtDt3
} from '../../../../../redux/episode/cmpTab/cmpForm/cmpSlice';
import { CmpTitle } from '../../../../ui/styled';

const CmpORAS = (props) => {
  const dispatch = useDispatch();
  const { control, register } = props;
  return (
    <>
      <Grid item xs={12}>
        <Typography pt={2} align="center" variant='h5'>Based on the Domain of the ORAS</Typography>
      </Grid>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={4}>
          <CmpTitle variant='h6'>Goals</CmpTitle>
          <FormInputText
            name='orasGls1'
            type='text'
            control={control}
            multiline={true}
            //rows={4}
            register={register('orasGls1', {
              onBlur: (e) => dispatch(setOrasGls1(e.target.value)),
            })}
          />
        </Grid>  

        <Grid item xs={12} sm={4}>
          <CmpTitle variant='h6'>Objectives</CmpTitle>
          <FormInputText
            name='orasObj1'
            type='text'
            control={control}
            multiline={true}
            //rows={4}
            register={register('orasObj1', {
              onBlur: (e) => dispatch(setOrasObj1(e.target.value)),
            })}
          />
        </Grid>

        <Grid item xs={12} sm={4}>
          <CmpTitle variant='h6'>Projected Target Dates</CmpTitle>
          <CMPFormInputText
            name='orasTgtDt1'
            type='date'
            control={control}
            shrink={true}
            register={register('orasTgtDt1', {
              onBlur: (e) => dispatch(setOrasTgtDt1(e.target.value)),
            })}
            label='Target Date'
          />
          <CMPFormInputText
            name='oracCmpDt1'
            type='date'
            control={control}
            shrink={true}
            register={register('oracCmpDt1', {
              onBlur: (e) =>
                dispatch(setOracCmpDt1(e.target.value)),
            })}
            label='Completed On'
          />
        </Grid>  

        <Grid item xs={12} sm={4}>
          <FormInputText
            name='orasGls2'
            type='text'
            control={control}
            multiline={true}
            //rows={4}
            register={register('orasGls2', {
              onBlur: (e) => dispatch(setOrasGls2(e.target.value)),
            })}
          />
        </Grid>

        <Grid item xs={12} sm={4}>
          <FormInputText
            name='orasObj2'
            type='text'
            control={control}
            multiline={true}
            //rows={4}
            register={register('orasObj2', {
              onBlur: (e) => dispatch(setOrasObj2(e.target.value)),
            })}
          />
        </Grid>

        <Grid item xs={12} sm={4}>
          <CMPFormInputText
            name='orasTgtDt2'
            type='date'
            control={control}
            shrink={true}
            register={register('orasTgtDt2', {
              onBlur: (e) => dispatch(setOrasTgtDt2(e.target.value)),
            })}
            label='Target Date'
          />
          <CMPFormInputText
            name='orasCmpDt2'
            type='date'
            control={control}
            shrink={true}
            register={register('orasCmpDt2', {
              onBlur: (e) =>
                dispatch(setOrasCmpDt2(e.target.value)),
            })}
            label='Completed On'
          />
        </Grid>

        <Grid item xs={12} sm={4}>
          <FormInputText
            name='orasGls3'
            type='text'
            control={control}
            multiline={true}
            //rows={4}
            register={register('orasGls3', {
              onBlur: (e) => dispatch(setOrasGls3(e.target.value)),
            })}
          />
        </Grid>

        <Grid item xs={12} sm={4}>
          <FormInputText
            name='orasObj3'
            type='text'
            control={control}
            multiline={true}
            //rows={4}
            register={register('orasObj3', {
              onBlur: (e) => dispatch(setOrasObj3(e.target.value)),
            })}
          />
        </Grid>

        <Grid item xs={12} sm={4}>
          <CMPFormInputText
            name='orasTgtDt3'
            type='date'
            control={control}
            shrink={true}
            register={register('orasTgtDt3', {
              onBlur: (e) => dispatch(setOrasTgtDt3(e.target.value)),
            })}
            label='Target Date'
          />
          <CMPFormInputText
            name='orasCmpDt3'
            type='date'
            control={control}
            shrink={true}
            register={register('orasCmpDt3', {
              onBlur: (e) =>
                dispatch(setOrasCmpDt3(e.target.value)),
            })}
            label='Completed On'
          />
        </Grid>

      </Grid>
    </>
  );
};

export default CmpORAS;
